document.addEventListener('DOMContentLoaded', function () {
    var controller = new ScrollMagic.Controller();
    var t = new TimelineMax();
    t.add(TweenLite.to('#product-image', 10, { css: { scale: 1, opacity: 1 }, ease: Linear.ease }))
        .add(TweenLite.fromTo('.qr20-text-container .one', 10, { x: '100%' }, { css: { x: '0%' }, ease: Linear.ease }))
        .add(TweenLite.to('.qr20-text-container .one', 10, { css: { opacity: 0.5, scale: 0.9 }, ease: Linear.ease }))
        .add(TweenLite.fromTo('.qr20-text-container .two', 10, { x: '100%' }, { css: { x: '0%' }, ease: Linear.ease }))
        .add(TweenLite.to('.qr20-text-container .two', 10, { css: { scale: 1 }, ease: Linear.ease }))
        .add(TweenLite.fromTo('.logo-contianer', 10, { x: '100%' }, { css: { x: '0%' }, ease: Linear.ease }))
        .add(TweenLite.fromTo('.logo-contianer .second-logo', 40, { x: '0%' }, { css: { x: '-72%' }, ease: Linear.ease }))
        .add(TweenLite.to('#product-image', 40, { css: { scale: 1 }, ease: Linear.ease }))
        .add(TweenLite.to('#product-image', 10, { css: { scale: 0.8, y: '-100px' }, ease: Linear.ease }))
        .add(TweenLite.to('.qr20-first-item .one-item', 30, { css: { opacity: 0 }, ease: Linear.ease }))
        .add(TweenLite.to('.qr20-first-item .second-item', 10, { css: { opacity: 1 }, ease: Linear.ease }))
        // 标题初始 visibility:hidden，避免 WAVE 把 opacity:0 算成对比度不足；动画开始再显示
        .add(TweenLite.to('#si-title', 10, { css: { y: '-60px', opacity: 1, visibility: 'visible' }, ease: Linear.easeOut }))
        .add(TweenLite.to('.si-bottom-content', 10, { css: { y: '-60px', opacity: 1 }, ease: Linear.easeOut }));
    // build scene
    if ($(window).width() > 1921) {
        var scene = new ScrollMagic.Scene({ triggerElement: '#ct-1', duration: 3000, offset: 540 })
            .setTween(t)
            .setPin('#ct-1')
            .addTo(controller);
    } else {
        var scene = new ScrollMagic.Scene({ triggerElement: '#ct-1', duration: 3000, offset: 460 })
            .setTween(t)
            .setPin('#ct-1')
            .addTo(controller);
    }
});